<template>
  <div class="status-change-audit"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="auditInfo">
      <template v-if="auditTypes && auditTypes.length">
        <MenuTabs v-model="current"
                  title="选择审核类型">
          <el-tab-pane v-for="auditType in auditTypes"
                       :key="auditType.code"
                       :name="auditType.code"
                       :label="`${auditType.name}（${auditType.count || 0}）`"
                       lazy>
            <div class="audit-pane">
              <component :is="auditCache[auditType.code]"
                         :active="auditType.code === current"
                         @refresh="loadAuditInfo"></component>
            </div>
          </el-tab-pane>
        </MenuTabs>
      </template>
      <template v-else>
        <Hint>
          <span>没有可审核的类型</span>
        </Hint>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>审核数据加载失败</div>
        <el-button size="mini"
                   type="text"
                   @click="loadAuditInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import MenuTabs from '../../../../../../widgets/custom/MenuTabs'
import StatusChangeAuditSuspend from './suspend'
import StatusChangeAuditDropout from './dropout'
import StatusChangeAuditRollClass from './roll-class'
import Hint from '../../../../../../elements/Hint'
import changeType from '../../../../../../../constants/biz/status/changeType'
export default {
  name: 'StatusChangeAudit',
  components: {
    MenuTabs,
    Hint
  },
  data () {
    return {
      loading: false,
      auditInfo: null,
      current: '',
      auditCache: {
        [changeType.SUSPEND.code]: StatusChangeAuditSuspend,
        [changeType.ROLL_CLASS.code]: StatusChangeAuditRollClass,
        [changeType.DROPOUT.code]: StatusChangeAuditDropout
      }
    }
  },
  computed: {
    auditTypes () {
      let auditInfo = this.auditInfo
      if (auditInfo) {
        return auditInfo.auditTypes
      }
    }
  },
  methods: {
    loadAuditInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/status/change/audit/auditInfo',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.auditInfo = response.data['auditInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadAuditInfo()
  },
  activated () {
    this.loadAuditInfo()
  },
  watch: {
    auditTypes (val) {
      if (val && val.length) {
        if (this.current) {
          if (!val.find(item => item.code === this.current)) {
            this.current = val[0].code
          }
        } else {
          this.current = val[0].code
        }
      } else {
        this.current = ''
      }
    }
  }
}
</script>

<style lang="scss">
  .status-change-audit {
    height: 100%;
    .audit-pane {
      height: 100%;
      .el-tabs {
        position: relative;
        height: 100%;
        & > .el-tabs__header {
          padding-left: 15px;
          padding-right: 15px;
          background-color: #fafafa;
          margin-bottom: 0;
          .el-tabs__nav-wrap {
            &:after {
              display: none;
            }
            .el-tabs__nav-scroll {
              .el-tabs__nav {
                .el-tabs__item {
                  height: 40px;
                  font-size: 12px;
                  line-height: 40px;
                }
              }
            }
          }
        }
        & > .el-tabs__content {
          position: absolute;
          left: 0;
          top: 40px;
          right: 0;
          bottom: 0;
          .el-tab-pane {
            height: 100%;
          }
        }
      }
    }
  }
</style>
